<template>
    <Layout>
        <Heading :error="props.error" :offers="props.primeTimeOffers" />

        <Information :stats="props.stats" />

        <FeaturedOffers v-if="props.promotedOffers.length" :offers="props.promotedOffers" />

        <Team />
    </Layout>
</template>

<script setup>
    import Heading from '@/Partials/Home/Heading';
    import Information from '@/Partials/Home/Information.vue';
    import FeaturedOffers from '../Partials/Home/FeaturedOffers.vue';
    import Team from '../Partials/Home/Team.vue';

    const props = defineProps({
        error: Boolean,
        primeTimeOffers: Array,
        promotedOffers: Array,
        stats: Object,
    });
</script>
